/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Brackets = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M16 3h3v18h-3" }],
    ["path", { d: "M8 21H5V3h3" }]
  ]
];

export { Brackets as default };
//# sourceMappingURL=brackets.js.map
